import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { orderService, ShopContext } from '../shop/shop-context';
import { distinctUntilUserChanged } from '../../utilities/observable.helper';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { OrdersComponent } from './orders';
import { Order } from '../models/order';
import removeClass from '@opten/dom/remove-class';
import addClass from '@opten/dom/add-class';

@Component({ className: 'js-shop-orders__navigation--mobile' })
export class OrdersMobileNav implements OnInit {
	@ComponentRef(ShopContext) shopContext: ShopContext;

	constructor(private element: HTMLElement) {}

	onInit() {
		const type = this.element.getAttribute('data-type');

		this.shopContext.onAuthenticationChanged.pipe(distinctUntilUserChanged()).subscribe(user => {
			const customerId = user.customerId.toString();
			const parent = this.element.parentElement;
			const loader = parent.querySelector('.js-shop-orders__loader');

			if (type) {
				this.element.addEventListener('click', e => {
					removeClass(loader, 'd-none');
					switch (type) {
						case 'open':
							e.preventDefault();
							orderService.get(customerId).subscribe(orders => {
								parent.innerHTML += this.renderNavigation(orders, type);
								this.hideLoader(parent);
							});
							break;
						case 'archived':
							e.preventDefault();
							orderService.getArchive(customerId).subscribe(orders => {
								parent.innerHTML += this.renderNavigation(orders, type);
								this.hideLoader(parent);
							});
							break;
						default:
							break;
					}
				});
			}
		});
	}

	private renderNavigation(orders: Order[], type: string) {
		if (orders && orders.length) {
			const years = OrdersComponent._groupByYear(orders, 'orderDate');
			const items = Object.entries(years)
				.sort((a, b) => b[0].localeCompare(a[0]))
				.map((year: any[], index) => {
					let isOpen = false;
					if (window.location.hash) {
						isOpen = !!year[1].find(o => o.orderNo === window.location.hash.substring(1));
					} else {
						isOpen = index === 0;
					}

					const ords = year[1].map(o => {
						return `<li class="c-sidenav__orders__item">
									<a href="${this.element.getAttribute('href')}#${o.orderNo}" title="${o.orderNo}">
										<span>${OrdersComponent._formateDate(o.orderDate)}</span>
										<span>${o.orderNo}</span>
									</a>
								</li>`;
					});

					return `<li class="c-sidenav__orders__year">
								<button data-toggle="collapse" href="#m-${type}-year-${year[0]}" class="${isOpen ? 'is--active' : ''}">
									${year[0]}
									<span class="material-icons">expand_more</span>
								</button>
								<ul id="m-${type}-year-${year[0]}" data-parent="#m-${type}-years" class="c-sidenav__orders__list js-collapse collapse ${
						isOpen ? 'collapse--show' : ''
					}">
									${ords.join('')}
								</ul>
							</li>`;
				});

			return `<ul class="c-sidenav__orders" id="m-${type}-years">${items.join('')}</ul>`;
		}

		return '';
	}

	private hideLoader(parent: HTMLElement) {
		const loader = parent.querySelector('.js-shop-orders__loader');
		addClass(loader, 'd-none');
	}
}
